import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { ModalOptionPanelComponent } from '../../modal-option-panel/modal-option-panel.component';
import { LanguageService } from 'src/app/services/account/language.service';

@Component({
  standalone: true,
  selector: 'app-account-forgot-password-step',
  templateUrl: './forgot-password-step.component.html',
  styleUrls: ['./forgot-password-step.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, ModalOptionPanelComponent]
})
export class ForgotPasswordStepComponent {
  @Input() formGroup: FormGroup | null = null;
  @Input() existingEmailMsg: string | null = null;
  @Input() emailSent: boolean = false;

  constructor(public languageService: LanguageService) {}

  get recoveryEmail() { return this.formGroup!.get('recoveryEmail')!; }
}
